import type { AllRouteEndpoints } from "../routeTypes";

export const engagementWebhookTemplatesUpdateArchivedStateCacheKeys: AllRouteEndpoints[] = [
  "/engagement/webhook_templates/:id",
  "/engagement/webhook_templates",
];
